import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/AuthProvider';
import { api } from '@/lib/api';
import type { MyPreferences } from '@/lib/types';

export const PREFS_KEY = ['me', 'preferences'] as const;

/**
 * تفضيلاتُ الشخص من الخادم لا من المتصفّح (27 سبتمبر 2026): اختصاراتُه تتبعه على جواله وحاسوبه،
 * والجولةُ الإرشادية لا تُعاد على جهازٍ جديد لمن رآها. والطلبُ بلا سياق مؤسسة — النطاقُ هو الشخص.
 */
export function usePreferences() {
  const { me } = useAuth();
  return useQuery({
    queryKey: PREFS_KEY,
    queryFn: () => api.get<MyPreferences>('/me/preferences', { institutionId: null }),
    enabled: !!me,
    staleTime: 5 * 60_000,
  });
}
